import { ref } from "vue";

export function useTabVisibility() {
  const actuationsNames = ref({
    "sumario-denuncia": "Sumario Prevencional Por Denuncia",
    "sumario-oficio": "Sumario Prevencional Por Oficio",
    "expediente-denuncia": "Expediente Contravencional por denuncia",
    "expediente-oficio": "Expediente Contravencional por oficio",
    "ufi-flagrancia": "Unidades Fiscales de Investigacion Flagrancia",
    "ufi-generica-denuncia": "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia",
    "ufi-propiedad-denuncia":
      "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
    "ufi-informatica-denuncia":
      "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Denuncia",
    "ufi-generica-oficio": "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
    "ufi-propiedad-oficio":
      "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio",
    "ufi-informatica-oficio":
      "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Oficio",
    "ufi-cavig": "Unidades Fiscales de Investigacion CAVIG",
    "ufi-anivi": "Unidades Fiscales de Investigacion ANIVI",
    "ufi-establecer-paradero": "Unidades Fiscales de Investigacion D.E Establecer Paradero",
    "ufi-generico-establecer-paradero":
      "Unidades Fiscales de Investigación Delitos Genéricos Establecer Paradero",
    "ufi-emergencias-medicas": "Unidades Fiscales de Investigacion D.E Emergencias Medicas",
    "ufi-siniestro-vial": "Unidades Fiscales de Investigacion D.E Siniestro Vial",
    "ufi-otros": "Unidades Fiscales de Investigacion D.E Otros",
    "ufi-suicidio": "Unidades Fiscales de Investigacion D.E Ahorcamiento o Suicidio",
    "ufi-incendio-vivienda": "Unidades Fiscales de Investigacion D.E Incendio en Vivienda",
    "ufi-intoxicacion": "Unidades Fiscales de Investigacion D.E Intoxicacion",
    "preliminares-incendio-vivienda": "Actuacion Preliminar por Incendio en Vivienda",
    "preliminares-establecer-procedencia": "Actuacion Preliminar para Establecer Procedencias",
    "preliminares-fuga-menor": "Actuacion Preliminar por Fuga de Menor",
    "preliminares-siniestro-vial": "Actuacion Preliminar por Siniestro Vial",
    "preliminares-caida-casual": "Actuacion Preliminar por Caida Casual",
    "preliminares-incendio-automotor": "Actuacion Preliminar por Incendio de Automotor",
    "preliminares-suicidio": "Actuacion Preliminar por Tentativa de Suicidio",
    "preliminares-otros": "Actuacion Preliminar - Otros",
  });

  const allowedActuation = ref({
    interveningPersonnel: [
      "sumario-oficio",
      "expediente-oficio",
      "ufi-generica-oficio",
      "ufi-anivi",
      "ufi-flagrancia",
      "ufi-propiedad-oficio",
      "ufi-cavig",
      "ufi-informatica-oficio",
      "ufi-emergencias-medicas",
      "ufi-siniestro-vial",
      "ufi-suicidio",
      "ufi-incendio-vivienda",
      "ufi-intoxicacion",
      "preliminares-incendio-vivienda",
      "preliminares-establecer-procedencia",
      "preliminares-fuga-menor",
      "preliminares-siniestro-vial",
      "preliminares-caida-casual",
      "preliminares-incendio-automotor",
      "preliminares-suicidio",
      "preliminares-otros",
      "ufi-otros",
    ],
    patrimonialAffectation: ["ufi-informatica-oficio", "ufi-informatica-denuncia"],
    vinculateds: [
      "sumario-denuncia",
      "sumario-oficio",
      "expediente-denuncia",
      "expediente-oficio",
      "ufi-flagrancia",
      "ufi-generica-denuncia",
      "ufi-propiedad-denuncia",
      "ufi-informatica-denuncia",
      "ufi-generica-oficio",
      "ufi-propiedad-oficio",
      "ufi-informatica-oficio",
      "ufi-cavig",
      "ufi-anivi",
      "ufi-establecer-paradero",
      "ufi-generico-establecer-paradero",
      "ufi-siniestro-vial",
      "ufi-otros",
      "preliminares-incendio-vivienda",
      "preliminares-establecer-procedencia",
      "preliminares-fuga-menor",
      "preliminares-suicidio",
      "preliminares-otros",
    ],
  });

  // Abreviadas -> Nombres completos
  const abbrToFull = (abbrs = []) => {
    const map = actuationsNames.value;
    return Array.isArray(abbrs) ? abbrs.map((k) => map[k] ?? k) : [];
  };

  // Nombres completos -> Abreviadas
  const fullToAbbr = (fulls = []) => {
    const inverted = Object.fromEntries(
      Object.entries(actuationsNames.value).map(([abbr, full]) => [full, abbr])
    );
    return Array.isArray(fulls) ? fulls.map((k) => inverted[k] ?? k) : [];
  };

  const determineVisibility = (tabType, currentActuation) => {
    if (tabType === undefined) return;
    const currentActuationFullName = fullToAbbr([currentActuation])[0];
    return allowedActuation.value[tabType].includes(currentActuationFullName);
  };

  return {
    determineVisibility,
    abbrToFull,
    fullToAbbr,
  };
}
